import { EventBusEvent } from '@app/engine/events/event-bus-events';
import { ConeMesh } from './cone-mesh';
import { CustomMeshFactory } from './custom-mesh-factory';
import { EventBus } from '@app/engine/events/event-bus';
export class ConeMeshFactory extends CustomMeshFactory {
    defaultConeSettings_ = {
        fieldOfView: 3,
        color: [0.2, 1.0, 1.0, 0.15],
    };
    drawAll(pMatrix, camMatrix, tgtBuffer) {
        this.meshes.forEach((mesh) => {
            mesh.draw(pMatrix, camMatrix, tgtBuffer);
        });
    }
    updateAll() {
        this.meshes.forEach((mesh) => {
            mesh.update();
        });
    }
    generateMesh(cone, settings = this.defaultConeSettings_) {
        const foundSensorFovMesh = this.checkCacheForMesh_(cone);
        if (foundSensorFovMesh) {
            return;
        }
        this.create_(cone, settings);
    }
    checkCacheForMesh_(coneAttachPoint) {
        return this.meshes.find((mesh) => mesh.obj.id === coneAttachPoint.id);
    }
    editSettings(settings) {
        this.defaultConeSettings_ = settings;
    }
    create_(coneAttachPoint, settings) {
        const sensorFovMesh = new ConeMesh(coneAttachPoint, settings);
        this.add(sensorFovMesh);
        EventBus.getInstance().emit(EventBusEvent.ConeMeshUpdate);
    }
    remove(id) {
        this.meshes.splice(id, 1);
        EventBus.getInstance().emit(EventBusEvent.ConeMeshUpdate);
    }
    removeByObjectId(id) {
        const index = this.meshes.findIndex((mesh) => mesh.obj.id === id);
        if (index !== -1) {
            this.remove(index);
        }
        EventBus.getInstance().emit(EventBusEvent.ConeMeshUpdate);
    }
}
